<div class="tab-gestion-navette">
	<p-confirmDialog></p-confirmDialog>
	<p-tabView class="tabview">
		<p-tabPanel class="tabview" header="{{ 'GESTION_NAVETTE.TRAJETS.TITRE_TRAJETS' | translate }}">
			<app-trajets></app-trajets>
		</p-tabPanel>
	</p-tabView>
</div>